import {
  ADD_FILES,
  REMOVE_FILE,
  RESET_FILES,
  RESET_STATE,
  SET_CONFIDENTIAL_CHECKED,
  SET_CONFIDENTIAL_SELECTION,
  SET_CONSTRUCTED_FILES,
  SET_DISPLAY_PROGRESS,
  SET_ENABLE,
  SET_ERROR_MESSAGE,
  SET_EXCEEDED_FILES,
  SET_FILES,
  SET_FILES_ADDED,
  SET_FILE_CLASSIFICATION_SELECTION,
  SET_INTERNAL_CHECKED,
  SET_INTERNAL_SELECTION,
  SET_IS_UPLOADING,
  SET_RESTRICTED_CHECKED,
  SET_RESTRICTED_SELECTION,
  SET_UPLOADED_FILES,
  SET_UPLOADED_FILES_SUCCESS,
  SET_UPLOAD_PROGRESS,
} from "../actionTypes/intakeActionTypes";

interface FileState {
  files: File[];
  errorMessage: string | null;
  exceededFiles: string[];
  isUploading: boolean;
  displayProgress: boolean;
  uploadedFiles: string[];
  uploadedFilesSuccess: string[];
  uploadProgress: Record<string, number>;
  constructedFiles: any[];
  isFilesAdded: boolean;
  setEnable: boolean;
  confidentialChecked: boolean;
  restrictedChecked: boolean;
  internalChecked: boolean;
  internalSelection: Record<string, string | undefined>;
  confidentialSelection: Record<string, string | undefined>;
  restrictedSelection: Record<string, string | undefined>;
  fileClassificationSelection: Record<string, string | undefined>;
}

const initialState: FileState = {
  files: [],
  errorMessage: null,
  exceededFiles: [],
  isUploading: false,
  displayProgress: false,
  uploadedFiles: [],
  uploadedFilesSuccess: [],
  uploadProgress: {},
  constructedFiles: [],
  isFilesAdded: false,
  setEnable: false,
  confidentialChecked: false,
  restrictedChecked: false,
  internalChecked: false,
  confidentialSelection: {},
  restrictedSelection: {},
  internalSelection: {},
  fileClassificationSelection: {},
};

const intakeReducer = (state = initialState, action: any): FileState => {
  switch (action.type) {
    case SET_FILES:
      return {
        ...state,
        files: action.payload,
      };
    case RESET_FILES:
      return {
        ...state,
        files: [],
      };
    case ADD_FILES:
      return {
        ...state,
        files: [...state.files, ...action.payload],
      };
    case REMOVE_FILE:
      return {
        ...state,
        files: state.files.filter((file) => file.name !== action.payload),
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_EXCEEDED_FILES:
      return {
        ...state,
        exceededFiles: action.payload,
      };
    case SET_IS_UPLOADING:
      return { ...state, isUploading: action.payload };
    case SET_DISPLAY_PROGRESS:
      return { ...state, displayProgress: action.payload };
    case SET_UPLOADED_FILES:
      return { ...state, uploadedFiles: action.payload };
    // case SET_UPLOADED_FILES_SUCCESS:
    //     return { ...state, uploadedFilesSuccess: action.payload };
    case SET_UPLOADED_FILES_SUCCESS:
      return {
        ...state,
        uploadedFilesSuccess: [
          ...state.uploadedFilesSuccess,
          ...action.payload.filter(
            (file: string) => !state.uploadedFilesSuccess.includes(file)
          ),
        ],
      };
    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: {
          ...state.uploadProgress,
          [action.payload.fileName]: action.payload.progress,
        },
      };
    case SET_CONSTRUCTED_FILES:
      return { ...state, constructedFiles: action.payload };
    case RESET_STATE:
      return {
        ...initialState,
      };
    case SET_FILES_ADDED:
      return {
        ...state,
        isFilesAdded: action.payload,
      };
    case SET_ENABLE:
      return {
        ...state,
        setEnable: action.payload,
      };

    case SET_CONFIDENTIAL_CHECKED:
      return {
        ...state,
        confidentialChecked: action.payload,
      };
    case SET_RESTRICTED_CHECKED:
      return {
        ...state,
        restrictedChecked: action.payload,
      };
    case SET_INTERNAL_CHECKED:
      return {
        ...state,
        internalChecked: action.payload,
      };

    case SET_CONFIDENTIAL_SELECTION:
      return {
        ...state,
        confidentialSelection: action.payload,
      };
    case SET_RESTRICTED_SELECTION:
      return {
        ...state,
        restrictedSelection: action.payload,
      };
    case SET_INTERNAL_SELECTION:
      return {
        ...state,
        internalSelection: action.payload,
      };
    case SET_FILE_CLASSIFICATION_SELECTION:
      return {
        ...state,
        fileClassificationSelection: action.payload,
      };
    default:
      return state;
  }
};

export default intakeReducer;
